import { useRef } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { IconAddPlus } from '@components/icons/add-plus';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

export const FileUploadAnother = observer(({ disabled, error, onChange }) => {
  const inputRef = useRef();
  const { t } = useStore();

  const changeFile = (e) => {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;
    if (onChange) {
      onChange(file);
    }
  };

  const uploadClick = () => {
    inputRef.current.click();
  };

  return (
    <Stack space={0} orientation="horizontal" justify="flex-end">
      <Container
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            uploadClick();
          }
        }}
        tabIndex={0}
        onClick={disabled ? null : uploadClick}
        filled={false}
        disabled={disabled}
        error={error}
      >
        <Stack space={2} orientation="horizontal">
          <IconAddPlus />
          <Text font="semibold14" color="purple80">
            {t('helpers.add')}
          </Text>
        </Stack>
      </Container>
      <input ref={inputRef} style={{ display: 'none' }} type="file" onChange={changeFile} />
    </Stack>
  );
});

const Container = styled.div((p) => ({
  padding: '0.5rem 1rem 0.5rem 0.5rem',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: p.theme.colors.purpleTrans5,
  color: p.theme.colors.purple50,
  alignItems: 'center',
  height: '2.5rem',
  borderRadius: '0.25rem',
  cursor: 'pointer',
  ...(!p.filled && {
    ':hover, :focus': {
      backgroundColor: p.theme.colors.purpleTrans10,
      color: p.theme.colors.purple80,
    },
  }),
}));
